module.exports = __webpack_public_path__ + "img/profilo-alertduedate.229aa442.png";